import { useEffect } from "react";
import { useMultiAgentStore } from "@/stores/multiAgentStore";
import { useRecentRuns } from "./useRecentRuns";

export interface UseSessionHistoryReturn {
  runs: ReturnType<typeof useRecentRuns>["runs"];
}

/**
 * Fetches the user's recent multi-agent runs and syncs them into the store's
 * history list so the HistoryDrawer and session-resolution logic share one
 * source of truth without each component re-fetching.
 */
export function useSessionHistory(): UseSessionHistoryReturn {
  const setHistory = useMultiAgentStore((s) => s.setHistory);
  const { runs } = useRecentRuns({ enabled: true });

  useEffect(() => {
    setHistory(runs);
  }, [runs, setHistory]);

  return { runs };
}
